/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.coanimation.ts
 *
 * Messages de la COANIMATION à l'inscription (2026-10-08) : un animateur
 * peut rejoindre un atelier déjà créé par un collègue au lieu d'être obligé
 * d'en créer un doublon. Fusionné dans fr.ts.
 *
 * Constat de départ : deux animatrices d'une même structure coaniment un
 * atelier ; la seconde restait bloquée à l'étape « atelier » de son
 * inscription, le titre d'un nouvel atelier y étant obligatoire.
 *
 * « Atelier » n'est jamais écrit en dur : jetons {lex...}. Apostrophe
 * typographique partout. Aucun tiret cadratin.
 *
 * Mikael - chef de projet - 2026-10-08
 */
export const messagesCoanimationFr: Record<string, string> = {
  'coanimation.titre': 'Vous coanimez {lexWorkshopIndef} déjà créé{lexWorkshopAgr} ?',
  'coanimation.aide':
    'Si un ou une collègue l’a déjà inscrit{lexWorkshopAgr}, cochez sa case : vous n’avez rien d’autre à remplir, vous l’animerez ensemble.',
  'coanimation.memeStructure': 'Votre structure',
  'coanimation.brouillon': 'Brouillon',
  'coanimation.heure': '{jour} à {heure}',
  'coanimation.ou': 'Ou créez {lexWorkshopIndef} :',
  'coanimation.facultatif':
    'Facultatif si vous avez coché {lexWorkshopIndef} ci-dessus. Laissez ces champs vides si vous ne créez rien.',
  'coanimation.erreur.rien':
    'Cochez une case ci-dessus, ou donnez un titre à {lexWorkshopIndef} à créer.',
  'coanimation.recap.rejoints': '{lexWorkshopPluralCap} rejoint{lexWorkshopAgrPlural}',
  'coanimation.recap.crees': '{lexWorkshopPluralCap} créé{lexWorkshopAgrPlural}',
  'coanimation.valider': 'Créer mon compte',
  'coanimation.valider.aide':
    'Votre compte sera rattaché {lexWorkshopAtPlural} coché{lexWorkshopAgrPlural} ci-dessus. Leur publication reste gérée par la personne qui les a créé{lexWorkshopAgrPlural} et par l’organisation.',
  'coanimation.successBody':
    'Votre compte est créé, et votre badge vous attend. Connectez-vous par e-mail pour le retrouver et suivre les inscriptions depuis « Mon espace animateur ».',
  'coanimation.succes':
    'Vous êtes animateur ou animatrice de : {titres}.',
};
